import { ODSFooter, ODSFooterMenuItem } from '@telekom-ods/react-ui-kit';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

const Footer = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const renderNavItem = (to: string, label: string) => (
    <ODSFooterMenuItem
      text={label}
      onClick={() => {
        navigate(to);
      }}
    />
  );

  return (
    <ODSFooter
      copyrightText={intl.formatMessage({ id: 'copyrightText' })}
      variant='minimal'
    >
      {renderNavItem('/contact-us', intl.formatMessage({ id: 'contact' }))}
      {renderNavItem('/gtc', intl.formatMessage({ id: 'termsAndConditions' }))}
      {renderNavItem('/about-us', intl.formatMessage({ id: 'imprint' }))}
      {renderNavItem('/data-privacy', intl.formatMessage({ id: 'dataPrivacy' }))}
    </ODSFooter>
  );
};

export default Footer;
